import "./styles.scss";

import CardCreateSignerForm from "components/card-send-create/card-create-signers/card-create-signer-form";
import AnimateHeight from "components/ui/animate-height";
import { BaIconChevronDown, BaIconChevronRight, BaIconChevronUp, BaIconContactCard, BaIconLink, BaIconPencil } from "components/ui/icons";
import { useMember } from "hooks/member";
import { PropTypes } from "prop-types";
import React, { useState } from "react";

const CardCreateSignerOptions = ({ focusRef, cardSend, withSignersList, setSignerStep, setShowAuthwallPopup, onChange, onErrors }) => {
  const { memberId } = useMember();
  const [showSignersList, setShowSignersList] = useState(false);

  const { signers } = cardSend;

  const inviteSigners = signers?.filter((s) => s.inviteEmail) || [];

  const onContactsClick = () => {
    if (memberId) {
      setSignerStep("contacts");
    } else {
      setShowAuthwallPopup && setShowAuthwallPopup("signers");
    }
  };

  return (
    <div className="card-create-signer-options-container">
      {withSignersList && inviteSigners.length > 0 && (
        <>
          <div className="card-create-signers-list-toggle" onClick={() => setShowSignersList(!showSignersList)}>
            <span>Manage Signers ({inviteSigners.length})</span>
            {!showSignersList ? <BaIconChevronDown /> : <BaIconChevronUp />}
          </div>
          <AnimateHeight toggled={showSignersList}>
            <div className="card-create-signers-list">
              {inviteSigners.map((s, i) => (
                <CardCreateSignerForm
                  key={`card-create-edit-signer-form-${s.cardSignerId}`}
                  cardSend={cardSend}
                  signer={s}
                  index={i}
                  onErrors={onErrors}
                  onChange={onChange}
                />
              ))}
            </div>
          </AnimateHeight>
        </>
      )}
      <div className="card-create-signers-menu">
        <button className="card-create-signers-menu-item flex-menu-item" onClick={onContactsClick} ref={focusRef}>
          <BaIconContactCard className="menu-item-icon" />
          <span>
            <span className="mobile-hidden">SELECT FROM&nbsp;</span>MY CONTACTS
          </span>
          <BaIconChevronRight className="arrow-icon" />
        </button>
        <button className="card-create-signers-menu-item flex-menu-item" onClick={() => setSignerStep("link")}>
          <BaIconLink className="menu-item-icon" />
          <span>SHARE A LINK</span>
          <BaIconChevronRight className="arrow-icon" />
        </button>
        <button className="card-create-signers-menu-item flex-menu-item" onClick={() => setSignerStep("manual")}>
          <BaIconPencil className="menu-item-icon" />
          <span>ENTER MANUALLY</span>
          <BaIconChevronRight className="arrow-icon" />
        </button>
      </div>
    </div>
  );
};

CardCreateSignerOptions.propTypes = {
  focusRef: PropTypes.object,
  cardSend: PropTypes.object.isRequired,
  setSignerStep: PropTypes.func.isRequired,
  setShowAuthwallPopup: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  onErrors: PropTypes.func.isRequired,
  withSignersList: PropTypes.bool,
};

export default CardCreateSignerOptions;
